import { c as _c } from "react/compiler-runtime";
import { getOperationName } from '@data-access/lib/execute';
import { AddItemToWishlistDocument, CreateWishlistDocument, DeleteWishlistDocument, RemoveItemFromWishlistDocument, RenameWishlistDocument, SwitchWishlistsDocument, WishlistDocument } from '@data-access/lib/gql/wishlists/documents';
import { useGraphQLMutation } from '@data-access/lib/graphql-query';
import { useQueryClient } from '@tanstack/react-query';
import { useWishlists } from './use-wishlists';

// Prefix key: invalidates every Wishlist query regardless of variables.
const wishlistQueryKey = [getOperationName(WishlistDocument)] as const;
export const useWishlistMutation = () => {
  const $ = _c(22);
  const {
    refetchWishlists
  } = useWishlists();
  const queryClient = useQueryClient();
  const {
    mutateAsync: createWishlist
  } = useGraphQLMutation(CreateWishlistDocument);
  let t0;
  if ($[0] !== queryClient || $[1] !== refetchWishlists) {
    t0 = {
      onSuccess: () => {
        refetchWishlists?.();
        queryClient.invalidateQueries({
          queryKey: wishlistQueryKey
        });
      }
    };
    $[0] = queryClient;
    $[1] = refetchWishlists;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const {
    mutateAsync: switchWishlists
  } = useGraphQLMutation(SwitchWishlistsDocument, t0);
  let t1;
  if ($[3] !== queryClient || $[4] !== refetchWishlists) {
    t1 = {
      onSuccess: () => {
        refetchWishlists?.();
        queryClient.invalidateQueries({
          queryKey: wishlistQueryKey
        });
      }
    };
    $[3] = queryClient;
    $[4] = refetchWishlists;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    mutateAsync: renameWishlist
  } = useGraphQLMutation(RenameWishlistDocument, t1);
  let t2;
  if ($[6] !== refetchWishlists) {
    t2 = {
      onSuccess: () => {
        refetchWishlists?.();
      }
    };
    $[6] = refetchWishlists;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    mutateAsync: deleteWishlist
  } = useGraphQLMutation(DeleteWishlistDocument, t2);
  let t3;
  if ($[8] !== queryClient || $[9] !== refetchWishlists) {
    t3 = {
      onSuccess: () => {
        refetchWishlists?.();
        queryClient.invalidateQueries({
          queryKey: wishlistQueryKey
        });
      }
    };
    $[8] = queryClient;
    $[9] = refetchWishlists;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const {
    mutateAsync: addItemToWishlist,
    isPending: addLoading
  } = useGraphQLMutation(AddItemToWishlistDocument, t3);
  let t4;
  if ($[11] !== queryClient || $[12] !== refetchWishlists) {
    t4 = {
      onSuccess: () => {
        refetchWishlists?.();
        queryClient.invalidateQueries({
          queryKey: wishlistQueryKey
        });
      }
    };
    $[11] = queryClient;
    $[12] = refetchWishlists;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const {
    mutateAsync: removeItemFromWishlist,
    isPending: removeLoading
  } = useGraphQLMutation(RemoveItemFromWishlistDocument, t4);
  const t5 = addLoading || removeLoading;
  let t6;
  if ($[14] !== addItemToWishlist || $[15] !== createWishlist || $[16] !== deleteWishlist || $[17] !== removeItemFromWishlist || $[18] !== renameWishlist || $[19] !== switchWishlists || $[20] !== t5) {
    t6 = {
      createWishlist,
      switchWishlists,
      addItemToWishlist,
      removeItemFromWishlist,
      renameWishlist,
      deleteWishlist,
      isLoading: t5
    };
    $[14] = addItemToWishlist;
    $[15] = createWishlist;
    $[16] = deleteWishlist;
    $[17] = removeItemFromWishlist;
    $[18] = renameWishlist;
    $[19] = switchWishlists;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};